(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-art-wall"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__rbWallEventsBound) return;
  window.__rbWallEventsBound = true;
  const WA='https://wa.me/5491150064248?text=';

  const closeDialog=(dialog)=>{
    if(!dialog)return;
    if(typeof dialog.close==='function'&&dialog.open)dialog.close(); else dialog.removeAttribute('open');
    document.documentElement.classList.remove('rb-modal-open');
  };

  const openDialog=(button)=>{
    const root=button.closest('.rb-art-wall');
    if(!root)return;
    const dialog=root.querySelector('[data-rb-wall-dialog]');
    const image=root.querySelector('[data-rb-wall-image]');
    const title=root.querySelector('[data-rb-wall-title]');
    const meta=root.querySelector('[data-rb-wall-meta]');
    const link=root.querySelector('[data-rb-wall-link]');
    const wa=root.querySelector('[data-rb-wall-wa]');
    const room=root.querySelector('[data-rb-wall-room]');
    const favorite=root.querySelector('[data-rb-favorite-action]');
    if(!dialog||!image||!title||!meta)return;
    const workTitle=button.dataset.title||'esta obra';
    image.src=button.dataset.image||'';
    image.alt=button.dataset.alt||workTitle;
    title.textContent=workTitle;
    meta.textContent=button.dataset.meta||'';
    if(wa)wa.href=WA+encodeURIComponent('Hola, estoy viendo “'+workTitle+'” en la web de Raúl Blisniuk y quisiera consultar por esta obra.');
    if(room)room.href=WA+encodeURIComponent('Hola, estoy viendo “'+workTitle+'” en la web de Raúl Blisniuk. Quisiera verla en mi espacio. Puedo enviar una foto frontal de la pared y una medida de referencia.');
    if(favorite){
      favorite.dataset.favoriteTitle=workTitle;
      favorite.dataset.favoriteImage=button.dataset.image||'';
      favorite.dataset.favoriteMeta=button.dataset.meta||'';
      favorite.dataset.favoriteSeries='Selección de obras';
      favorite.dataset.favoriteUrl=button.dataset.link||'';
      window.RBFavorites?.syncButton(favorite);
    }
    if(link){
      if(button.dataset.link){link.href=button.dataset.link;link.hidden=false;}
      else{link.hidden=true;link.removeAttribute('href');}
    }
    if(typeof dialog.showModal==='function')dialog.showModal(); else dialog.setAttribute('open','');
    document.documentElement.classList.add('rb-modal-open');
  };

  document.addEventListener('click',(event)=>{
    const open=event.target.closest('[data-rb-wall-open]');
    if(open){event.preventDefault();openDialog(open);return;}
    const close=event.target.closest('[data-rb-wall-close]');
    if(close){event.preventDefault();closeDialog(close.closest('dialog'));return;}
    const dialog=event.target.closest('[data-rb-wall-dialog]');
    if(dialog&&event.target===dialog)closeDialog(dialog);
  });
  document.addEventListener('keydown',(event)=>{
    if(event.key!=='Escape')return;
    document.querySelectorAll('[data-rb-wall-dialog][open]').forEach(closeDialog);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-catalog-viewer"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__rbCatalogViewerBound) return;
  window.__rbCatalogViewerBound = true;
  const WA='https://wa.me/5491150064248?text=';

  const thumbUrl=(url)=>{
    if(!url)return '';
    if(/cdn\.shopify\.com/.test(url)){
      if(/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/,'$1240');
      return url+(url.includes('?')?'&':'?')+'width=240';
    }
    return url;
  };

  const categoryOf=(work)=>{
    const hay=(work.series+' '+work.title+' '+work.meta).toLowerCase();
    if(hay.includes('ravik')||hay.includes('zoo')) return 'ravik';
    if(hay.includes('inspired')||hay.includes('inspir')) return 'inspired';
    if(hay.includes('abstract')) return 'abstract';
    if(hay.includes('car hood')||hay.includes('capot')||hay.includes('hood')) return 'hoods';
    if(/mixed media|totem|bust|chair|trade|sculpt|fiberglass|resin|deep|porcelain/.test(hay)) return 'volume';
    return 'other';
  };

  const init=()=>{
    const viewer=document.querySelector('.rb-catalog-viewer');
    if(!viewer || viewer.dataset.ready==='true') return;
    viewer.dataset.ready='true';

    const stage=viewer.querySelector('[data-rb-catalog-stage]');
    const visual=viewer.querySelector('[data-rb-catalog-visual]');
    const railWrap=viewer.querySelector('[data-rb-catalog-rail-wrap]');
    const rail=viewer.querySelector('[data-rb-catalog-rail]');
    const filter=viewer.querySelector('[data-rb-catalog-filter]');
    const mainImage=viewer.querySelector('[data-rb-catalog-image]');
    const title=viewer.querySelector('[data-rb-catalog-title]');
    const meta=viewer.querySelector('[data-rb-catalog-meta]');
    const seriesLabel=viewer.querySelector('[data-rb-catalog-series]');
    const counter=viewer.querySelector('[data-rb-catalog-counter]');
    const total=viewer.querySelector('[data-rb-catalog-total]');
    const link=viewer.querySelector('[data-rb-catalog-link]');
    const wa=viewer.querySelector('[data-rb-catalog-wa]');
    const room=viewer.querySelector('[data-rb-catalog-room]');
    const rental=viewer.querySelector('[data-rb-catalog-rental]');
    const favorite=viewer.querySelector('[data-rb-favorite-action]');
    const similarBox=viewer.querySelector('[data-rb-catalog-similar] > div');
    const quick=[...viewer.querySelectorAll('[data-rb-catalog-category]')];

    const works=[];
    document.querySelectorAll('.rb-gallery-series').forEach((section)=>{
      const heading=section.querySelector('.rb-gallery-series__header h2')?.textContent?.trim()||'Obras';
      const anchor=section.id||heading.toLowerCase();
      section.querySelectorAll('[data-rb-gallery-open]').forEach((button)=>{
        const item={
          title:button.dataset.title||'Obra',
          meta:button.dataset.meta||'',
          image:button.dataset.image||'',
          alt:button.dataset.alt||button.dataset.title||'Obra de Raúl Blisniuk',
          link:button.dataset.link||'',
          series:heading,
          seriesId:anchor
        };
        item.category=categoryOf(item);
        if(item.image)works.push(item);
      });
    });
    if(!works.length)return;
    if(total)total.textContent=works.length;

    const series=[...new Map(works.map(w=>[w.seriesId,w.series])).entries()];
    series.forEach(([id,name])=>{
      const option=document.createElement('option');
      option.value=id; option.textContent=name; filter.appendChild(option);
    });

    let filtered=[...works],current=0,category='all';

    const setFavorite=(work)=>{
      if(!favorite)return;
      favorite.dataset.favoriteTitle=work.title;
      favorite.dataset.favoriteImage=work.image;
      favorite.dataset.favoriteMeta=work.meta;
      favorite.dataset.favoriteSeries=work.series;
      favorite.dataset.favoriteUrl=work.link||'';
      window.RBFavorites?.syncButton(favorite,work);
    };

    const setActions=(work)=>{
      wa.href=WA+encodeURIComponent('Hola, estoy viendo “'+work.title+'” en el catálogo de Raúl Blisniuk y quisiera consultar por esta obra.');
      room.href=WA+encodeURIComponent('Hola, estoy viendo “'+work.title+'” en el catálogo de Raúl Blisniuk. Quisiera verla en mi espacio. Puedo enviar una foto frontal de la pared y una medida de referencia.');
      rental.href=WA+encodeURIComponent('Hola, estoy viendo “'+work.title+'” en el catálogo de Raúl Blisniuk y quisiera saber si esta obra participa del programa de alquiler.');
      if(work.link){link.href=work.link;link.hidden=false;}else{link.hidden=true;link.removeAttribute('href');}
      setFavorite(work);
    };

    const renderSimilar=(work)=>{
      similarBox.innerHTML='';
      const list=works.filter(x=>x.seriesId===work.seriesId && x.title!==work.title).slice(0,4);
      if(!list.length){viewer.querySelector('[data-rb-catalog-similar]').hidden=true;return;}
      viewer.querySelector('[data-rb-catalog-similar]').hidden=false;
      list.forEach((item)=>{
        const b=document.createElement('button'); b.type='button'; b.className='rb-catalog-similar';
        const img=document.createElement('img'); img.src=thumbUrl(item.image); img.alt=item.title; img.loading='lazy'; img.decoding='async';
        const s=document.createElement('span'); s.textContent=item.title;
        b.append(img,s); b.addEventListener('click',()=>{filtered=[...works];current=works.indexOf(item);filter.value='all';category='all';quick.forEach(x=>x.classList.toggle('is-active',x.dataset.rbCatalogCategory==='all'));renderRail();window.RBTrack?.('similar_open',{artwork:item.title});});
        similarBox.appendChild(b);
      });
    };

    const renderMain=()=>{
      const work=filtered[current]; if(!work)return;
      mainImage.src=work.image; mainImage.alt=work.alt;
      title.textContent=work.title; meta.textContent=work.meta||'Datos técnicos en actualización.';
      seriesLabel.textContent=work.series; counter.textContent=(current+1)+' / '+filtered.length;
      setActions(work); renderSimilar(work);
      rail.querySelectorAll('[data-rb-catalog-thumb]').forEach((button,i)=>{button.classList.toggle('is-active',i===current);button.setAttribute('aria-current',i===current?'true':'false');});
      rail.querySelector('[data-rb-catalog-thumb].is-active')?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    };

    const renderRail=()=>{
      rail.innerHTML='';
      filtered.forEach((work,i)=>{
        const button=document.createElement('button');button.type='button';button.className='rb-catalog-thumb';button.dataset.rbCatalogThumb='true';button.setAttribute('aria-label','Ver '+work.title);
        const img=document.createElement('img');img.src=thumbUrl(work.image);img.alt='';img.loading='lazy';img.decoding='async';
        const label=document.createElement('span');label.textContent=work.title;
        button.append(img,label);button.addEventListener('click',()=>{current=i;renderMain();window.RBTrack?.('catalog_thumb',{artwork:work.title});});rail.appendChild(button);
      });
      current=Math.min(current,Math.max(0,filtered.length-1));renderMain();
    };

    const applyCategory=(value)=>{
      category=value;filter.value='all';
      filtered=value==='all'?[...works]:works.filter(w=>w.category===value);
      if(!filtered.length)filtered=[...works];
      current=0;quick.forEach(x=>x.classList.toggle('is-active',x.dataset.rbCatalogCategory===value));
      renderRail();window.RBTrack?.('catalog_filter',{filter:value,count:filtered.length});
    };

    quick.forEach(btn=>btn.addEventListener('click',()=>applyCategory(btn.dataset.rbCatalogCategory)));
    filter.addEventListener('change',()=>{
      const value=filter.value; category='all'; quick.forEach(x=>x.classList.toggle('is-active',x.dataset.rbCatalogCategory==='all'));
      filtered=value==='all'?[...works]:works.filter(w=>w.seriesId===value); current=0; renderRail(); window.RBTrack?.('catalog_filter',{filter:value,count:filtered.length});
    });

    const prev=()=>{current=(current-1+filtered.length)%filtered.length;renderMain();};
    const next=()=>{current=(current+1)%filtered.length;renderMain();};
    viewer.querySelector('[data-rb-catalog-prev]').addEventListener('click',prev);
    viewer.querySelector('[data-rb-catalog-next]').addEventListener('click',next);
    viewer.querySelector('[data-rb-catalog-rail-prev]').addEventListener('click',()=>rail.scrollBy({left:-Math.max(300,rail.clientWidth*.75),behavior:'smooth'}));
    viewer.querySelector('[data-rb-catalog-rail-next]').addEventListener('click',()=>rail.scrollBy({left:Math.max(300,rail.clientWidth*.75),behavior:'smooth'}));

    let touchX=0;
    visual.addEventListener('touchstart',(e)=>{touchX=e.changedTouches[0].clientX;},{passive:true});
    visual.addEventListener('touchend',(e)=>{const dx=e.changedTouches[0].clientX-touchX;if(Math.abs(dx)>55)(dx<0?next():prev());},{passive:true});

    viewer.addEventListener('keydown',(event)=>{if(event.key==='ArrowLeft')prev();if(event.key==='ArrowRight')next();});

    const archiveButton=viewer.querySelector('[data-rb-toggle-archive]');
    archiveButton.addEventListener('click',()=>{
      const open=document.documentElement.classList.toggle('rb-archive-open');
      archiveButton.textContent=open?'Ocultar archivo completo ↑':'Explorar archivo completo ↓';
      if(open)document.querySelector('.rb-gallery-series')?.scrollIntoView({behavior:'smooth',block:'start'});
      window.RBTrack?.('archive_toggle',{open});
    });

    stage.hidden=false;railWrap.hidden=false;renderRail();
    document.documentElement.classList.add('rb-catalog-enhanced');
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-gallery-series"] && !Shopify.designMode) return;
  try {
    
(() => {
  if(window.__rbGalleryEventsBound)return;
  window.__rbGalleryEventsBound=true;
  const WA='https://wa.me/5491150064248?text=';
  const closeDialog=(dialog)=>{
    if(!dialog)return;
    if(typeof dialog.close==='function'&&dialog.open)dialog.close(); else dialog.removeAttribute('open');
    document.documentElement.classList.remove('rb-modal-open');
  };
  const openDialog=(button)=>{
    const root=button.closest('.rb-gallery-series');
    if(!root)return;
    const dialog=root.querySelector('[data-rb-gallery-dialog]');
    const image=root.querySelector('[data-rb-gallery-image]');
    const title=root.querySelector('[data-rb-gallery-title]');
    const meta=root.querySelector('[data-rb-gallery-meta]');
    const link=root.querySelector('[data-rb-gallery-link]');
    const wa=root.querySelector('[data-rb-gallery-wa]');
    const room=root.querySelector('[data-rb-gallery-room]');
    const favorite=root.querySelector('[data-rb-favorite-action]');
    const similar=root.querySelector('[data-rb-gallery-similar] > div');
    if(!dialog||!image||!title||!meta)return;
    const workTitle=button.dataset.title||'esta obra';
    image.src=button.dataset.image||'';
    image.alt=button.dataset.alt||workTitle;
    title.textContent=workTitle;
    meta.textContent=button.dataset.meta||'';
    if(wa)wa.href=WA+encodeURIComponent('Hola, estoy viendo “'+workTitle+'” en la web de Raúl Blisniuk y quisiera consultar por esta obra.');
    if(room)room.href=WA+encodeURIComponent('Hola, estoy viendo “'+workTitle+'” en la web de Raúl Blisniuk. Quisiera verla en mi espacio. Puedo enviar una foto frontal de la pared y una medida de referencia.');
    if(favorite){
      favorite.dataset.favoriteTitle=workTitle;
      favorite.dataset.favoriteImage=button.dataset.image||'';
      favorite.dataset.favoriteMeta=button.dataset.meta||'';
      favorite.dataset.favoriteSeries=root.querySelector('.rb-gallery-series__header h2')?.textContent?.trim()||'Galería';
      favorite.dataset.favoriteUrl=button.dataset.link||'';
      window.RBFavorites?.syncButton(favorite);
    }
    if(similar){
      similar.innerHTML='';
      [...root.querySelectorAll('[data-rb-gallery-open]')].filter(x=>x!==button).slice(0,4).forEach((other)=>{
        const b=document.createElement('button');b.type='button';b.className='rb-gallery-similar';
        const im=document.createElement('img');im.src=other.dataset.image||'';im.alt=other.dataset.title||'Obra';im.loading='lazy';im.decoding='async';
        const s=document.createElement('span');s.textContent=other.dataset.title||'Obra';
        b.append(im,s);b.addEventListener('click',()=>openDialog(other));similar.appendChild(b);
      });
    }
    if(link){
      if(button.dataset.link){link.href=button.dataset.link;link.hidden=false;}
      else{link.hidden=true;link.removeAttribute('href');}
    }
    if(typeof dialog.showModal==='function')dialog.showModal(); else dialog.setAttribute('open','');
    document.documentElement.classList.add('rb-modal-open');
  };
  document.addEventListener('click',(event)=>{
    const open=event.target.closest('[data-rb-gallery-open]');
    if(open){event.preventDefault();openDialog(open);return;}
    const close=event.target.closest('[data-rb-gallery-close]');
    if(close){event.preventDefault();closeDialog(close.closest('dialog'));return;}
    const dialog=event.target.closest('[data-rb-gallery-dialog]');
    if(dialog&&event.target===dialog)closeDialog(dialog);
  });
  document.addEventListener('keydown',(event)=>{
    if(event.key!=='Escape')return;
    document.querySelectorAll('[data-rb-gallery-dialog][open]').forEach(closeDialog);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-site-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  if(window.__rbSmartHeader)return;
  window.__rbSmartHeader=true;
  const header=document.querySelector('.rb-site-header');
  if(!header)return;
  let last=window.scrollY;
  const update=()=>{
    const compact=window.scrollY>120;
    header.classList.toggle('is-compact',compact);
    last=window.scrollY;
  };
  update();
  window.addEventListener('scroll',update,{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-video-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__rbVideoShowcaseBound) return;
  window.__rbVideoShowcaseBound = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rb-video-load]');
    if (!button) return;
    event.preventDefault();

    const id = button.dataset.videoId;
    if (!id) return;

    const frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
    frame.title = button.getAttribute('aria-label') || 'YouTube video';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.allowFullscreen = true;
    frame.loading = 'lazy';
    frame.className = 'rb-video-card__iframe';

    button.replaceWith(frame);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
